import { cn } from "@/modern/utils";

/** Shared stacked form field label — Details form + Access + Promote. */
export const FILE_DETAIL_FIELD_LABEL_CLS =
  "mb-1.5 block text-sm font-normal uppercase tracking-wide text-muted-foreground";

/** Same label type, for a row with a trailing control (help icon). */
export const FILE_DETAIL_FIELD_LABEL_INLINE_CLS =
  "text-sm font-normal uppercase tracking-wide text-muted-foreground";

/** Shared control chrome so textarea and selects read as one form. */
export const FILE_DETAIL_FIELD_CONTROL_CLS =
  "w-full rounded-md border border-input bg-background text-sm shadow-none";

/**
 * Focus ring for text fields in the rail — inset so overflow-y shells do not clip left/right.
 */
export const FILE_DETAIL_FIELD_FOCUS_CLS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset focus-visible:ring-offset-0";

/**
 * Select trigger focus — inset ring so overflow-hidden rail shells do not clip the outline.
 */
export const FILE_DETAIL_SELECT_TRIGGER_CLS = cn(
  FILE_DETAIL_FIELD_CONTROL_CLS,
  "h-9 focus:ring-2 focus:ring-ring focus:ring-inset focus:ring-offset-0",
);

/** Above FileDetailModal shell (bryntum + 10). */
export const FILE_DETAIL_SELECT_CONTENT_CLS =
  "z-[calc(var(--swivu-bryntum-z-index)+20)]";
